<template>
  <a-drawer
    placement="right"
    :visible="isLimitDialogShow"
    width="800px"
    :mask-closable="false"
    wrap-class-name="set-json-drawer"
    @close="closeHandler"
  >
    <div
      slot="title"
      class="title clearfix"
    >
      <h2 class="fl">
        推送数据
      </h2>
      <span class="tit-inqury">相关星轨信息：<router-link
        :to="{
          name: item.inquirystatus === 1 ? 'InqueryPassDetail' : 'InqueryDetail',
          params: {
            // pid: this.pid,
            inquiryId: item.inquiryid
          },
          query: {
            from: 'webhook',
            hookid: $route.params.hookid
          }
        }"
      >{{ datas.inquiry_code }}</router-link></span>
    </div>
    <div class="set-json-box">
      <div
        class="code-mirror-container"
        :style="`height: ${h}px;`"
      >
        <div
          class="code-mirror-box clearfix"
          :style="`height: ${h-2}px;`"
        >
          <div
            ref="codeMirror"
            class="code-mirror"
          >
            <codemirror
              ref="jsonEditor"
              v-model="jsonData"
              :options="options"
              :disabled="true"
              :style="`{height: ${h-2}px;}`"
            />
          </div>
        </div>
      </div>
    </div>
  </a-drawer>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { codemirror } from 'vue-codemirror'
import jsonlint from 'jsonlint'

import 'codemirror/lib/codemirror.css'
import 'codemirror/mode/javascript/javascript'
import 'codemirror/addon/selection/active-line'
import 'codemirror/mode/css/css'
import 'codemirror/theme/monokai.css'
import 'codemirror/keymap/sublime'

// 折叠
import 'codemirror/addon/fold/foldgutter.css'
import 'codemirror/addon/fold/foldcode'
import 'codemirror/addon/fold/foldgutter'
import 'codemirror/addon/fold/brace-fold'
import 'codemirror/addon/fold/comment-fold'
window.jsonlint = jsonlint
export default {
  components: {
    codemirror
  },
  props: {
    datas: {
      type: Object,
      default () {
        return {}
      }
    },
    item: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      isLimitDialogShow: false,
      confirmLoading: false,
      jsonData: '{}',
      isValid: true,
      ispopShow: false,
      h: 400
    }
  },
  computed: {
    ...mapState('config/webhook', ['jsonDatas']),
    ...mapGetters('config/webhook', ['jsonDataList']),
    options: function () {
      return {
        mode: 'application/ld+json',
        tabSize: 2,
        lineNumbers: true,
        foldGutter: true,
        lineWrapping: true,
        theme: 'default',
        // viewportMargin: Infinity,
        extraKeys: { 'Ctrl-Space': 'autocomplete' },
        styleActiveLine: true,
        // highlightDifferences: true,
        keyMap: 'sublime',
        // smartIndent: true,
        gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter', 'CodeMirror-lint-markers'],
        lint: true,
        autoRefresh: true
      }
    },
    codemirror () {
      return this.$refs.jsonEditor.codemirror
    }
  },
  inject: ['reload'],
  watch: {
    isLimitDialogShow (b) {
      if (b) {
        this.$nextTick(() => {
          this.setMirrorHeight()
          this.jsonData = JSON.stringify(this.datas.data, null, 2)
          this.codemirror.setValue((JSON.stringify(JSON.parse(this.jsonData), null, 2)))
          window.addEventListener('resize', this.setMirrorHeight)
          document.addEventListener('scroll', this.setMirrorHeigh)
        })
      }
    }
  },
  mounted () { },
  methods: {
    ...mapActions('config/allocationrule', ['setAllocationForm']),
    changeVisible (isShow) {
      this.isLimitDialogShow = isShow
    },
    // 代码格式化
    formatCode () {
      this.codemirror.setValue((JSON.stringify(JSON.parse(this.jsonData), null, 2)))
    },
    closeHandler () {
      this.isLimitDialogShow = false
      // this.reload()
    },
    setMirrorHeight () {
      this.h = document.body.clientHeight - 140
      this.codemirror.setSize('100%', this.h - 2 + 'px')
    }
  }
}
</script>
<style lang="scss" scoped>
.webhook-tip-d-t::v-deep {
    margin: -16px 0 16px;
    .ant-alert-info{
      border-color:#4CA0F2 ;
      background: #DBEDFF;
    }
  }
.code-mirror-container {
  height: 100%;
}

.code-mirror-box {
  border: 1px solid #ebebeb;
  // margin-top: 16px;
  overflow: hidden;
  .code-mirror {
    // width: 642px;
    // border-right: 1px solid #ebebeb;
    height: 100%;
  }
}
.tit-inqury {
  float: left;
  margin: 10px 0 0 8px;
  font-size: 14px;
}
</style>
<style lang="scss">
 .CodeMirror-lint-tooltip {
  z-index: 22222 !important;
  /* position: fixed !important; */
}
.set-json-drawer {
  .footer {
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 99;
    width: 100%;
    padding: 16px 0 16px 80px;
    border-top: 1px solid $gray4;
    background: #fff;
  }
  .ant-drawer-close {
    top: 20px;
    right: 20px;
    .ant-drawer-close-x {
       width: 32px;
    height: 32px;
    line-height: 32px;
    font-size: 32px;
    color: #ccc;
    }
  }
  .ant-drawer-content {
    padding: 0;
    border-bottom: none;
  }
  .ant-drawer-header {
    padding: 32px 40px;
    border-bottom: none;
  }
  .ant-drawer-title h2 {
    font-size: 32px;
    font-weight: 600;
  }
  .ant-drawer-body {
    padding: 0;
    height: 100%;
    .set-json-box {
      padding: 0 40px 64px;
      height: 100%;
    }
  }
}
.insert-var-popover {
  width: 436px;
  .ant-popover-inner-content {
    padding: 16px 4px 16px 16px;
  }
}
</style>
